import { deepClone } from "@mui/x-data-grid/utils/utils";
import { SchemePlaygroundType, cloneDataType } from "../../features/manageCoupons/types"

const initialState : SchemePlaygroundType = {
    data : {}
}

export const schemePlaygroundReducer = (state:SchemePlaygroundType = deepClone(initialState) , action:{payload:any , type:string})=>{
    switch(action.type){
       
        case 'cachePlayGroundScheme' : return {
            data : {
                ...state.data,
                [action.payload.schemeId] : action.payload.schemeData
            }
        }
        case 'postScheme':{
            const tempData = Object.entries(state.data).filter(([key, value])=>{
                return action.payload.schemeId != key;
            })
            let cloneData: cloneDataType = {};
            tempData.map(([key, value])=>{
                cloneData[key] = value;
            })
            return{
            data:{
                ...cloneData
            }
        }
    }
    case 'switchOffPlayGroundScheme' : return {
        data : {
           
        }
    }
        default: return state;
    }
}